import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from "axios";

const Balance = ({ isOpen, onClose, item_row, onModalClose}) => {
  const [modalOpen, setModalOpen] = useState(isOpen);

  const closeModal = () => {
    setModalOpen(false);
    onModalClose();
    onClose();
  };

  const [isCheckedh0, setCheckedH0] = useState(item_row.h0 == 1 ? true : false)
  const [isCheckedh1, setCheckedH1] = useState(item_row.h1 == 1 ? true : false)
  const [isCheckedh2, setCheckedH2] = useState(item_row.h2 == 1 ? true : false)
  const [isCheckedh3, setCheckedH3] = useState(item_row.h3 == 1 ? true : false)
  const [isCheckedh4, setCheckedH4] = useState(item_row.h4 == 1 ? true : false)
  const [isCheckedh5, setCheckedH5] = useState(item_row.h5 == 1 ? true : false)
  const [isCheckedh6, setCheckedH6] = useState(item_row.h6 == 1 ? true : false)
  const [isCheckedh7, setCheckedH7] = useState(item_row.h7 == 1 ? true : false)
  const [isCheckedh8, setCheckedH8] = useState(item_row.h8 == 1 ? true : false)
  const [isCheckedh9, setCheckedH9] = useState(item_row.h9 == 1 ? true : false)
  const [isCheckedh10, setCheckedH10] = useState(item_row.h10 == 1 ? true : false)
  const [isCheckedh11, setCheckedH11] = useState(item_row.h11 == 1 ? true : false)
  const [isCheckedh12, setCheckedH12] = useState(item_row.h12 == 1 ? true : false)
  const [isCheckedh13, setCheckedH13] = useState(item_row.h13 == 1 ? true : false)
  const [isCheckedh14, setCheckedH14] = useState(item_row.h14 == 1 ? true : false)
  const [isCheckedh15, setCheckedH15] = useState(item_row.h15 == 1 ? true : false)
  const [isCheckedh16, setCheckedH16] = useState(item_row.h16 == 1 ? true : false)
  const [isCheckedh17, setCheckedH17] = useState(item_row.h17 == 1 ? true : false)
  const [isCheckedh18, setCheckedH18] = useState(item_row.h18 == 1 ? true : false)
  const [isCheckedh19, setCheckedH19] = useState(item_row.h19 == 1 ? true : false)
  const [isCheckedh20, setCheckedH20] = useState(item_row.h20 == 1 ? true : false)
  const [isCheckedh21, setCheckedH21] = useState(item_row.h21 == 1 ? true : false)
  const [isCheckedh22, setCheckedH22] = useState(item_row.h22 == 1 ? true : false)
  const [isCheckedh23, setCheckedH23] = useState(item_row.h23 == 1 ? true : false)
  const update_hours = async(id, field, value)=>{
    if(field == "h0"){
        setCheckedH0(!isCheckedh0);
    }
    if(field == "h1"){
        console.log('got to h1')
        setCheckedH1(!isCheckedh1);
        console.log(isCheckedh1)
    }
    if(field == "h2"){
        setCheckedH2(!isCheckedh2);
    }
    if(field == "h3"){
        setCheckedH3(!isCheckedh3);
    }
    if(field == "h4"){
        setCheckedH4(!isCheckedh4);
    }
    if(field == "h5"){
        setCheckedH5(!isCheckedh5);
    }
    if(field == "h6"){
        setCheckedH6(!isCheckedh6);
    }
    if(field == "h7"){
        setCheckedH7(!isCheckedh7);
    }
    if(field == "h8"){
        setCheckedH0(!isCheckedh0);
    }
    if(field == "h8"){
        setCheckedH8(!isCheckedh8);
    }
    if(field == "h9"){
        setCheckedH9(!isCheckedh9);
    }
    if(field == "h10"){
        setCheckedH10(!isCheckedh10);
    }
    if(field == "h11"){
        setCheckedH11(!isCheckedh11);
    }
    if(field == "h12"){
        setCheckedH12(!isCheckedh12);
    }
    if(field == "h13"){
        setCheckedH13(!isCheckedh13);
    }
    if(field == "h14"){
        setCheckedH14(!isCheckedh14);
    }
    if(field == "h15"){
        setCheckedH15(!isCheckedh15);
    }
    if(field == "h16"){
        setCheckedH16(!isCheckedh16);
    }
    if(field == "h17"){
        setCheckedH17(!isCheckedh17);
    }
    if(field == "h18"){
        setCheckedH18(!isCheckedh18);
    }
    if(field == "h19"){
        setCheckedH19(!isCheckedh19);
    }
    if(field == "h20"){
        setCheckedH20(!isCheckedh20);
    }
    if(field == "h21"){
        setCheckedH21(!isCheckedh21);
    }
    if(field == "h22"){
        setCheckedH22(!isCheckedh22);
    }
    if(field == "h23"){
        setCheckedH23(!isCheckedh23);
    }

    
       
    axios
    .post("https://api.tydacomm.com/api/user/update-analysis", {
        id:id,
        field:field,
        value:value,
       
    })
    .then((response) => {
      //console.log(response)
    //  analysis()
    });
  }

  return (

    <Modal show={isOpen} onHide={closeModal}  size="lg">
    <Modal.Header >
      <Modal.Title>Balance Power for {item_row.item_name}</Modal.Title>
    </Modal.Header>
    <Modal.Body>

    <div class='table table-responsive'>
        <table class="table table-striped table-bordered table-sm">
            <thead>
                
                <tr>
                <th style={{textAlign:"center"}}>Time</th>
              <th style={{textAlign:"center"}}>Staus<br/>(On/Off)</th>
              
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>12am - 1am</td>
                    <td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h0_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h0', '1') : update_hours(item_row.row_id, 'h0', '0')}  checked={isCheckedh0}  /><label class='custom-control-label' for={item_row.h0_id}></label></div></td>
                </tr>
            
                <tr>
                    <td>1am - 2am</td>
                    <td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h1_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h1', '1') : update_hours(item_row.row_id, 'h1', '0')}  checked={isCheckedh1}  /><label class='custom-control-label' for={item_row.h1_id}></label></div></td>
                </tr>
                    <tr>
                    <td>2am - 3am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h2_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h2', '1') : update_hours(item_row.row_id, 'h2', '0')}  checked={isCheckedh2}  /><label class='custom-control-label' for={item_row.h2_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>3am - 4am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h3_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h3', '1') : update_hours(item_row.row_id, 'h3', '0')}  checked={isCheckedh3}  /><label class='custom-control-label' for={item_row.h3_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>4am - 5am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h4_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h4', '1') : update_hours(item_row.row_id, 'h4', '0')}  checked={isCheckedh4}  /><label class='custom-control-label' for={item_row.h4_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>5am - 6am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h5_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h5', '1') : update_hours(item_row.row_id, 'h5', '0')}  checked={isCheckedh5}  /><label class='custom-control-label' for={item_row.h5_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>6am - 7am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h6_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h6', '1') : update_hours(item_row.row_id, 'h6', '0')}  checked={isCheckedh6}  /><label class='custom-control-label' for={item_row.h6_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>7am - 8am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h7_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h7', '1') : update_hours(item_row.row_id, 'h7', '0')}  checked={isCheckedh7}  /><label class='custom-control-label' for={item_row.h7_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>8am - 9am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h8_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h8', '1') : update_hours(item_row.row_id, 'h8', '0')}  checked={isCheckedh8}  /><label class='custom-control-label' for={item_row.h8_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>9am - 10am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h9_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h9', '1') : update_hours(item_row.row_id, 'h9', '0')}  checked={isCheckedh9}  /><label class='custom-control-label' for={item_row.h9_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>10am - 11am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h10_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h10', '1') : update_hours(item_row.row_id, 'h10', '0')}  checked={isCheckedh10}  /><label class='custom-control-label' for={item_row.h10_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>11am - 12pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h11_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h11', '1') : update_hours(item_row.row_id, 'h11', '0')}  checked={isCheckedh11}  /><label class='custom-control-label' for={item_row.h11_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>12pm - 1pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h12_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h12', '1') : update_hours(item_row.row_id, 'h12', '0')}  checked={isCheckedh12}  /><label class='custom-control-label' for={item_row.h12_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>1pm - 2pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h13_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h13', '1') : update_hours(item_row.row_id, 'h13', '0')}  checked={isCheckedh13}  /><label class='custom-control-label' for={item_row.h13_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>2pm - 3pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h14_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h14', '1') : update_hours(item_row.row_id, 'h14', '0')}  checked={isCheckedh14}  /><label class='custom-control-label' for={item_row.h14_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>3pmm - 4pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h15_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h15', '1') : update_hours(item_row.row_id, 'h15', '0')}  checked={isCheckedh15}  /><label class='custom-control-label' for={item_row.h15_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>4pm - 5pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h16_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h16', '1') : update_hours(item_row.row_id, 'h16', '0')}  checked={isCheckedh16}  /><label class='custom-control-label' for={item_row.h16_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>5pm - 6pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h17_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h17', '1') : update_hours(item_row.row_id, 'h17', '0')}  checked={isCheckedh17}  /><label class='custom-control-label' for={item_row.h17_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>6pm - 7pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h18_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h18', '1') : update_hours(item_row.row_id, 'h18', '0')}  checked={isCheckedh18}  /><label class='custom-control-label' for={item_row.h18_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>7pm - 8pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h19_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h19', '1') : update_hours(item_row.row_id, 'h19', '0')}  checked={isCheckedh19}  /><label class='custom-control-label' for={item_row.h19_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>8pm - 9pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h20_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h20', '1') : update_hours(item_row.row_id, 'h20', '0')}  checked={isCheckedh20}  /><label class='custom-control-label' for={item_row.h20_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>9pm - 10pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h21_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h21', '1') : update_hours(item_row.row_id, 'h21', '0')}  checked={isCheckedh21}  /><label class='custom-control-label' for={item_row.h21_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>10pm - 11pm</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h22_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h22', '1') : update_hours(item_row.row_id, 'h22', '0')}  checked={isCheckedh22}  /><label class='custom-control-label' for={item_row.h22_id}></label></div></td>
                    </tr>
                    <tr>
                    <td>11pm - 12am</td><td style={{textAlign:"center"}}><div class='custom-control custom-switch'><input type='checkbox' class='custom-control-input'  id={item_row.h23_id} onChange={e => e.target.checked ? update_hours(item_row.row_id, 'h23', '1') : update_hours(item_row.row_id, 'h23', '0')}  checked={isCheckedh23}  /><label class='custom-control-label' for={item_row.h23_id}></label></div></td>
                    </tr>
            </tbody>
        </table>
        </div>
    
    

      

    </Modal.Body>
    <Modal.Footer>
    <Button variant="secondary" onClick={closeModal}>
        Close
      </Button>
      
    </Modal.Footer>
  </Modal>
  );
};

export default Balance;
